import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Box, Card, CardContent, CardMedia } from '@mui/material';
import rjames_headshot from '../../assets/images/RJames-Headshot-crop-circle_sm.png';
import caseyHeadshot from '../../assets/images/casey_headshot.png'
import balloons from '../../assets/images/hotairballoons_crop_914x748.png'
import '../../styles/mobidawg-style.scss';
import { analytics, logEvent } from '../../services/firebase.tsx';

function HomeBanner() {
    const location = useLocation();

    // A/B Test setup
    const variantToShow = 'B'; // 'A' for old, 'B' for new

    useEffect(() => {
        logEvent(analytics, 'home_banner_view', {
            ab_test_variant: `home_banner_variant_${variantToShow}`
        });
    }, [location, variantToShow]);

    const VariantA = () => (
        <>
            <Typography variant="body1" gutterBottom sx={{ color: '#00ff00', textAlign: "left", mb: 2, fontSize: '1.2rem', textShadow: '1px 1px 0px black' }}>
                Welcome to <span style={{ textShadow: '2px 2px 3px black', color: 'yellow' }}>mobidawg</span> where 
                you will find mobile experience delivered for fast-paced startup environments, as well as, complex 
                enterprise ecosystems.  Complete software development life cycle (SDLC) that is future-proofed 
                against the rapidly changing marketplace of technology and system integrations.
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ m: '1rem', color: '#f0f0f0', textAlign: "center", mb: 0, fontSize: '0.9rem', textShadow: '1px 1px 2px black' }}>
                Building mobile applications for business and entertainment.
            </Typography>
        </>
    );

    const VariantB = () => (
        <Typography variant="body1" gutterBottom sx={{ color: 'white', textAlign: "left", mb: 0, fontSize: '1.2rem', textShadow: '1px 1px 0px black' }}>
            Don't let AI leave your business behind. <span style={{ textShadow: '2px 2px 3px black', color: 'yellow' }}>mobidawg</span> can deliver practical, 
            step-by-step AI strategies, embedding intelligent agents into your web and mobile apps to drive real growth and efficiency.
        </Typography>
    );

    return (
            <Card sx={{ 
                position: 'relative', top: 0, left: 0, width: '100%',
                alignItems: 'center', mb: 4 }}>
                <CardContent sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundImage: `url(${balloons})`,  
                    backgroundPosition: 'left top', 
                    backgroundRepeat: 'no-repeat', 
                    backgroundSize: 'cover',
                    opacity: 0.9,
                    padding: 0,
                    mb: 0 }}>
                    <Box sx={{ 
                        display: 'flex', position: 'relative', top: 0, left: 0,
                        m: '1rem', p: 0, width: '100%', justifyContent: 'space-between', alignItems: 'top' }}>
                        <CardMedia 
                            component="img"
                            image={rjames_headshot}
                            alt="Headshot"
                            sx={{
                                width: 64,
                                height: 64,
                                borderRadius: '50%',
                                marginLeft: 2,
                                marginRight: 2,
                                zIndex: 2
                            }}
                        />

                        <CardMedia
                            component="img"
                            image={caseyHeadshot}
                            alt="Headshot"
                            sx={{
                                visibility: 'hidden',
                                width: 64,
                                height: 64,
                                borderRadius: '50%',
                                zIndex: 2
                            }}
                        />
                    </Box>

                    <Box sx={{
                        position: 'relative',
                        top: 10,
                        left: 0,
                        width: '86%',
                        display: 'flex',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 255, 0, 0.2)',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        color: 'pink',
                        textShadow: '1px 1px 2px black',
                        padding: '1rem'
                    }}>
                        {variantToShow === 'A' && <VariantA />}
                        {variantToShow === 'B' && <VariantB />}
                    </Box>
                </CardContent>
            </Card>
    );
}

export default HomeBanner;
